import { render, staticRenderFns } from "./AttachmentButton.vue?vue&type=template&id=24ebc1e8&scoped=true&"
import script from "./AttachmentButton.vue?vue&type=script&lang=js&"
export * from "./AttachmentButton.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentButton.vue?vue&type=style&index=0&id=24ebc1e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ebc1e8",
  null
  
)

export default component.exports